import ProductDescription from './product-description';

export default ProductDescription;